import {
  UploadIcon as LucideUploadIcon,
  CircleIcon as LucideCircleIcon,
  FolderPlusIcon as LucideFolderPlusIcon,
  PickaxeIcon as LucidePickaxeIcon,
  BookTextIcon as LucideBookTextIcon,
  BookOpenTextIcon as LucideBookOpenTextIcon,
  ScrollTextIcon as LucideScrollTextIcon,
  ClapperboardIcon as LucideClapperboardIcon,
  ClipboardListIcon as LucideClipboardListIcon,
  TentTreeIcon as LucideTentTreeIcon,
  HashIcon as LucideHashtagIcon,
  ChartPieIcon as LucideChartPieIcon,
} from 'lucide-react'

import { makeLucideIcon } from './makeLucideIcon'

/*
 * This file contains icons from Lucide (https://lucide.dev)
 *
 * Full Icon list here https://lucide.dev/icons/
 *
 * To add a new Lucide icon:
 * 1. Import the icon from 'lucide-react', e.g., import { IconName } from 'lucide-react'
 * 2. Export it using makeLucideIcon, e.g., export const IconName = makeLucideIcon(LucideIconName, 'IconName')
 * 3. The icon will automatically inherit Buffer's styling system
 *
 * For custom icons (not from Lucide), see the readme in the popcorn directory, under the section "How to generate icons"
 */

/**
 * Upload Icon
 */
export const UploadIcon = makeLucideIcon(LucideUploadIcon, 'UploadIcon')

/**
 * Circle Small Icon
 */
export const CircleIcon = makeLucideIcon(LucideCircleIcon, 'circle')

/**
 * Folder Plus Icon
 */
export const FolderPlusIcon = makeLucideIcon(
  LucideFolderPlusIcon,
  'FolderPlusIcon',
)

/**
 * Pickaxe Icon
 */
export const PickaxeIcon = makeLucideIcon(LucidePickaxeIcon, 'PickaxeIcon')

/**
 * Book Text Icon
 */
export const BookTextIcon = makeLucideIcon(LucideBookTextIcon, 'BookTextIcon')

/**
 * Book Open Text Icon
 */
export const BookOpenTextIcon = makeLucideIcon(
  LucideBookOpenTextIcon,
  'BookOpenTextIcon',
)

/**
 * Scroll Text Icon
 */
export const ScrollTextIcon = makeLucideIcon(
  LucideScrollTextIcon,
  'ScrollTextIcon',
)

/**
 * Clapperboard Icon
 */
export const ClapperboardIcon = makeLucideIcon(
  LucideClapperboardIcon,
  'ClapperboardIcon',
)

/**
 * Clipboard List Icon
 */
export const ClipboardListIcon = makeLucideIcon(
  LucideClipboardListIcon,
  'ClipboardListIcon',
)

/**
 * Tent Tree Icon
 */
export const TentTreeIcon = makeLucideIcon(LucideTentTreeIcon, 'TentTreeIcon')

/**
 * Hashtag Icon
 */
export const HashtagIcon = makeLucideIcon(LucideHashtagIcon, 'HashtagIcon')

/**
 * Chart Pie Icon
 */
export const ChartPieIcon = makeLucideIcon(LucideChartPieIcon, 'ChartPieIcon')
